export const borderRadius = 2;

// export const stylisticFont = 'Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol';
export const stylisticFont = 'Roboto, "Trebuchet MS", Helvetica, sans-serif';
export const bodyFont = 'Roboto, "Trebuchet MS", Helvetica, sans-serif';
export const skylineColor = 'red.500';
